import React, { useEffect, useState } from 'react';
import './ProductGallery.less';
import { Thumbnail } from './Thumbnail/Thumbnail';
import { MainImage } from './MainImage/MainImage';
import { getImageSrc } from '../../../utils/imageUrl';

// Cambiar a false cuando finalice el diagnostico.
const DEBUG_GALLERY = true;
const log = (event, data = {}) => {
  if (DEBUG_GALLERY) console.info(`[MS Gallery] ${event}`, data);
};

export function ProductGallery({
  images,
  productId,
  mainImageIndex,
  setMainImageIndex,
  isLoupeActive,
  setLoupeActive,
}) {
  const imagesList = Array.isArray(images) ? images : (images ? [images] : []);
  const [localIndex, setLocalIndex] = useState(0);
  const [events, setEvents] = useState<string[]>([]);

  const record = (name, data = {}) => {
    log(name, data);
    if (DEBUG_GALLERY) {
      setEvents(previous => [`${new Date().toLocaleTimeString()} ${name}`, ...previous].slice(0, 6));
    }
  };

  const activeIndex = mainImageIndex != null ? mainImageIndex : localIndex;
  const currentImage = imagesList[activeIndex] || imagesList[0] || '';
  const hasExtraImages = imagesList.length >= 6;
  const showMore = hasExtraImages && Boolean(productId);
  const visibleImages = showMore ? imagesList.slice(0, 5) : imagesList;
  const galleryUrl = productId
    ? `/productos/${encodeURIComponent(productId)}/galeria`
    : '';

  useEffect(() => {
    log('MOUNT / PROPS', {
      productId,
      count: imagesList.length,
      activeIndex,
      hasExtraImages,
      showMore,
      galleryUrl,
      currentImageUrl: currentImage ? getImageSrc(currentImage) : null,
    });
  }, [productId, images, mainImageIndex, activeIndex, hasExtraImages, showMore, galleryUrl, currentImage]);

  const handleSelectImage = (index) => {
    record('THUMBNAIL_SELECTED', { index });
    setLocalIndex(index);
    if (typeof setMainImageIndex === 'function') setMainImageIndex(index);
  };

  return (
    <div className="product-gallery-wrapper" style={{ width: '100%' }}>
      {DEBUG_GALLERY && (
        <aside style={{ width: '100%', padding: 12, marginBottom: 12, border: '2px solid #d9ad32', background: '#fff9df', color: '#222', fontSize: 13, borderRadius: 6, boxSizing: 'border-box' }}>
          <strong>DEBUG ProductGallery v2</strong>
          <div>ID: {String(productId ?? 'FALTA')}</div>
          <div>Imágenes: {imagesList.length} | Índice: {activeIndex} | Mostrar +: {String(showMore)}</div>
          {!productId && hasExtraImages && <div style={{ color: '#b00', fontWeight: 'bold' }}>ALERTA: falta pasar productId desde ProductIdScreen.</div>}
          {imagesList.length < 6 && <div>El botón + requiere al menos 6 imágenes.</div>}
          {events.map((event, i) => <div key={i}>{event}</div>)}
        </aside>
      )}

      <div className="product-gallery">
        <div className="gallery-thumbnails">
          {visibleImages.map((img, index) => (
            <Thumbnail
              key={index}
              src={getImageSrc(img)}
              isActive={index === activeIndex}
              onClick={() => handleSelectImage(index)}
              onMouseEnter={() => handleSelectImage(index)}
            />
          ))}

          {showMore && (
            <a
              className="thumbnail thumbnail-more"
              href={galleryUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`Ver todas las ${imagesList.length} fotografías`}
              onClick={() => record('CLICK_MORE', { galleryUrl })}
              style={{ position: 'relative', display: 'block', width: 76, height: 76, flex: '0 0 76px', overflow: 'hidden', border: '1px solid #ddd', borderRadius: 8 }}
            >
              <img
                src={getImageSrc(imagesList[5])}
                alt=""
                onLoad={() => log('MORE_IMAGE_LOADED')}
                onError={(e) => record('MORE_IMAGE_ERROR', { src: e.currentTarget.src })}
                style={{ width: '100%', height: '100%', objectFit: 'contain' }}
              />
              <span style={{ position: 'absolute', inset: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,.7)', color: 'white' }}>
                <strong style={{ fontSize: 30 }}>+</strong>
                <small>Ver todas</small>
              </span>
            </a>
          )}
        </div>

        <div className="main-image">
          <MainImage
            src={getImageSrc(currentImage)}
            isLoupeActive={isLoupeActive}
            setLoupeActive={setLoupeActive}
          />
        </div>
      </div>
    </div>
  );
}

export default ProductGallery;
